var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.options.video.url)?_c('div',{staticClass:"content-video",on:{"!contextmenu":function($event){return _vm.stop($event)}}},[_c('xt-dplayer',{staticClass:"video-player",attrs:{"options":_vm.options},on:{"playing":_vm.handleVideoPlaying}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }